export default "__VITE_ASSET__mB4nq025__"